import React from "react";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import Link from "@material-ui/core/Link";

import {Typography} from "@material-ui/core";
import {defaultSearchFilter} from "../../../utils/constants";
import {getUserVisibilityLevel} from "../../../utils";
import {showFaq} from "../services";
import useCountryAxiosInstance from "../../../hooks/useCountryAxiosInstance";

const useStyles = makeStyles(() => ({
  mainPaper: {
    marginTop: 10,
    padding: 15
  },
  button: {
    float: 'right'
  },
  link: {
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: 15
  }
}));

function SearchResultView({
                            searchResult,
                            tripletsSearchResult,
                            selectedSearchTab,
                            setSelectedSearchTab,
                            faqSelection,
                            setScrollToObject,
                            vmtSelection,
                            setEditableFaq,
                            toggleNewFaqDialog,
                            setNavigationStatus,
                            fetchFaqs,
                            isAdmin,
                            userData
                          }) {

  const classes = useStyles();
  const apiRequest = useCountryAxiosInstance();


  const showVerticalTab = (vertical) => {
    let questionCount = ((vertical === defaultSearchFilter) ? searchResult.length : searchResult.filter(val => val._source.vertical === vertical).length)
    return (
      <div key={vertical + 'searchTab'} style={{marginBottom: 5}}>
        <Link className={classes.link}
              onClick={() => {
                setSelectedSearchTab(vertical);
              }}>
          {vertical + ' (' + questionCount + ')'}
        </Link>
      </div>)
  }


  const isMobile = window.innerWidth < 500;
  const mainWidth = isMobile ? 12 : 9;

  const uniqueVerticals = [...new Set(tripletsSearchResult.map(item => item.vertical)), defaultSearchFilter];
  return (
    <>
      <Grid
        container
      >
        {(searchResult.length === 0 || tripletsSearchResult.length === 0) &&
        <div key='no_result_label' style={{margin: 5}}>
          <Typography variant="h6" align="center">
            Nessun risultato ottenuto
          </Typography>
        </div>

        }
        {!isMobile &&
        (searchResult.length > 0 && tripletsSearchResult.length > 0) &&
        <Grid item xs={3}>
          {Object.values(uniqueVerticals).map((vertical) =>
            showVerticalTab(vertical)
          )}
        </Grid>
        }
        <Grid item xs={mainWidth}>
          {Object.values(searchResult).map((question) => {
            let matching_vmt = tripletsSearchResult.find(x => (x.macrotema === question._source.macrotema) && (x.vertical === question._source.vertical))
            if (matching_vmt && getUserVisibilityLevel(userData) <= matching_vmt['riservato_kerakoll']) {
              return showFaq(question, 'faq_detail_from_search', selectedSearchTab, faqSelection, vmtSelection,
                setScrollToObject, setNavigationStatus, setEditableFaq, toggleNewFaqDialog, fetchFaqs, isAdmin, true, classes,apiRequest)
            } else return null
          })}

        </Grid>
      </Grid>

    </>
  )
}

export default SearchResultView;